__turbopack_context__.v({
  "className": "fredoka_98b5ef6-module__yD-ZVa__className",
});
